import { JSX, useState } from 'react'

import { Editable, IconButton, EditableRootProps, EditableValueChangeDetails } from '@chakra-ui/react'


import * as detective from '@/lib/detective.js'
import * as structure from '@/lib/structure.js'




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Control
(props: { children?: JSX.Element }): JSX.Element
{
	if (detective.is_empty(props.children) )
	{
		return (
			<></>

		)

	}

	return (
		<Editable.Control>
			<Editable.EditTrigger asChild>
				<IconButton variant="ghost" size="xs">{props.children}</IconButton>

			</Editable.EditTrigger>

		</Editable.Control>

	)

}


export type Tprops = Omit<EditableRootProps, 'placeholder' | 'onValueChange'>
	& {
		placeholder?: string

		change(value: string): void
		verify?(value: string): boolean

	}


// eslint-disable-next-line @typescript-eslint/naming-convention
export default function Default (props: Tprops): JSX.Element
{
	let [value, update_value] = useState(props.value ?? '')

	let placeholder = {
		edit   : props.placeholder ?? '',
		preview: detective.is_empty(props.placeholder) ? '无' : props.placeholder,

	}

	let on_update = (detail: EditableValueChangeDetails): void =>
	{
		let v = detail.value

		if (props.verify?.(v) === false)
		{
			v = ''

		}

		update_value(v)

	}

	let on_change = (): void =>
	{
		if (value === props.value)
		{
			return

		}

		props.change(value)

	}

	return (
		<Editable.Root
			{...structure.omit(props, 'change', 'verify')}
			value={value}
			placeholder={placeholder}
			onValueChange={on_update}
		>
			<Editable.Preview minW="48" color="fg" fontSize="xl" />

			<Editable.Input
				minW="48"
				color="fg"
				fontSize="xl"
				placeholder={props.placeholder}
				onBlur={on_change}
			/>

			{props.children}

		</Editable.Root>

	)

}




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Text
(
	props: Omit<Tprops, 'children'>
			& {
				icon?: JSX.Element

			},

)
:	JSX.Element
{
	return (
		<Default {...props}>
			<Control>{props.icon}</Control>

		</Default>

	)

}




// eslint-disable-next-line @typescript-eslint/naming-convention
export function RealNumber
(
	props: Omit<Tprops, 'value' | 'change' | 'children'>
			& {
				value: number
				change(value: number): void

				icon?: JSX.Element

				min?: number
				max?: number

			},

)
:	JSX.Element
{
	let value = ''

	let min = props.min ?? Number.NEGATIVE_INFINITY
	let max = props.max ?? Number.POSITIVE_INFINITY

	let verify = (v: string): boolean => Number.isFinite(Number(v) )

	if (Number.isFinite(props.value) )
	{
		let v = props.value

		v = Math.max(v, min)
		v = Math.min(v, max)

		if (v === 0)
		{
			value = ''

		}
		else
		{
			value = v.toString()

		}

	}

	let on_change = (v: string): void =>
	{
		let vv = Number(v)

		if (Number.isNaN(vv) )
		{
			vv = 0

		}

		props.change(vv)

	}

	return (
		<Default {...props} value={value} verify={verify} change={on_change}>
			<Control>{props.icon}</Control>

		</Default>

	)

}
